// extracted by mini-css-extract-plugin
export default {"Emojify":"bch_a bii_g"};